import { observable } from 'mobx'
import { storeContainer } from 'src/models'
import { convertToBoolean } from 'src/utils'

/**
 * MyAccountMenuDeps class.
 * Handles state and actions related to the my account menu.
 */
class MyAccountMenuDeps {
  @observable isMenuVisible = false

  /**
   * Toggles the visibility state of the my account menu.
   */
  toggleFilter = () => {
    this.isMenuVisible = !this.isMenuVisible
  }
}

const isFetchAllPromoCodeEnabled = () => {
  return (
    convertToBoolean(
      storeContainer.getStoreConfigProperty('promotionConfig')
        ?.fetchAllPromoCode
    ) || false
  )
}

const myAccountMenuDeps = new MyAccountMenuDeps()

export default myAccountMenuDeps
export { myAccountMenuDeps, isFetchAllPromoCodeEnabled }
